import { render, staticRenderFns } from "./RefsCompanyAddress.vue?vue&type=template&id=62da8143&scoped=true&"
import script from "./RefsCompanyAddress.vue?vue&type=script&lang=ts&"
export * from "./RefsCompanyAddress.vue?vue&type=script&lang=ts&"
import style0 from "./RefsCompanyAddress.vue?vue&type=style&index=0&id=62da8143&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62da8143",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
